import { useState, useEffect, useCallback } from "react";
import {
  collection, onSnapshot, addDoc, updateDoc, deleteDoc,
  doc, serverTimestamp, query, orderBy,
} from "firebase/firestore";
import { db } from "../firebase";

const COL = "prospects";

export function useProspects() {
  const [prospects, setProspects] = useState([]);
  const [loading, setLoading] = useState(true);


  // Real-time listener
  useEffect(() => {
    // Safety timeout — don't hang forever if Firestore is unreachable
    const timeout = setTimeout(() => setLoading(false), 5000);
    const q = query(collection(db, COL), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q,
      (snap) => {
        clearTimeout(timeout);
        setProspects(snap.docs.map((d) => ({ ...d.data(), id: d.id })));
        setLoading(false);
      },
      (err) => {
        clearTimeout(timeout);
        console.error("Firestore error:", err.message);
        setLoading(false);
      }
    );
    return () => { clearTimeout(timeout); unsub(); };
  }, []);

  const addProspect = useCallback(async (fields) => {
    await addDoc(collection(db, COL), {
      ...fields,
      source: fields.source || "Manual",
      status: fields.status || "identified",
      firstContact: null, lastContact: null, nextFollowUp: null,
      discoveryCallDate: null, proposalSent: null,
      createdAt: serverTimestamp(),
    });
  }, []);

  const updateProspect = useCallback(async (id, updates) => {
    await updateDoc(doc(db, COL, id), updates);
  }, []);

  const deleteProspect = useCallback(async (id) => {
    await deleteDoc(doc(db, COL, id));
  }, []);

  return { prospects, loading, addProspect, updateProspect, deleteProspect };
}
